import { FC, PropsWithChildren, useContext } from 'react';
import { LotCollectionResponse } from '../../api/dtos';
import LotsContext from '../../contexts/data/LotsContext';
import ProjectContext from '../../contexts/data/ProjectContext';
import StageContext from '../../contexts/data/StageContext';
import useLotsByProjectIdStageId from '../../hooks/data/useLotsByProjectIdStageId';


export interface ILotsProviderProps {
    initial?: LotCollectionResponse;
}

export const LotsProvider: FC<PropsWithChildren<ILotsProviderProps>> = ({ initial, children }) => {
    const { data: project } = useContext(ProjectContext);
    const { data: stage } = useContext(StageContext);
    const lots = useLotsByProjectIdStageId(project ? project?.id : undefined, stage ? stage?.id : undefined, { revalidateOnFocus: false, fallbackData: initial});

    return (
        <LotsContext.Provider value={lots}>
            {children}
        </LotsContext.Provider>
    );
}

export default LotsProvider;
